export const parseSpriteDescription = (description: string) => {
  const result: any = { skinColor: "", bodyType: "", clothes: [] };
  const parts = description?.split("-");
  parts?.forEach((part) => {
    const match = part.match(/^(\w+)\(([^:()]+)(?::([^:()]+))?\)$/);

    if (match) {
      const [, attribute, type, color] = match;

      if (attribute === "sk") {
        result.skinColor = type;
      } else if (attribute === "bd") {
        result.bodyType = type;
      } else {
        if (type && color) {
          result.clothes.push({
            part: attribute,
            type,
            color,
          });
        } else {
          result.clothes.push({
            part: attribute,
            type: null,
            color: null,
          });
        }
      }
    } else {
      console.warn(`Invalid format for part: ${part}`);
    }
  });

  return result;
};

export const normalizeAttribute = (attribute) => {
  const mapping = {
    hr: "hair",
    hd: "head",
    bd: "body",
    ts: "torso",
    lg: "legs",
  };

  return mapping[attribute] || attribute; // Return mapped value or original if no mapping exists
};

export const updateSpriteDescription = (description, updates) => {
  const parts = description?.split("-");

  const updatedParts = parts.map((part) => {
    const match = part.match(/^([a-z]{2})\(([^:()]+)(?::([^:()]+))?\)$/);
    if (match) {
      const [fullMatch, attribute, type, color] = match;

      // Find if this part needs to be updated
      const update = updates.find((u) => u.partToUpdate === attribute);

      if (update) {
        const updatedType = update.newType || type; // Keep existing type if newType is not provided
        const updatedColor = update.newColor || color; // Keep existing color if newColor is not provided
        return `${attribute}(${updatedType}${
          updatedColor ? ":" + updatedColor : ""
        })`;
      }
    }

    return part; // Return the part unchanged if no match or not the target part
  });

  return updatedParts.join("-");
};

export const getClothingByPart = (description, bodyPart) => {
  let result: { type: string; part: string; color: string } = {
    type: "",
    part: "",
    color: "",
  };
  const parts = description?.split("-");

  parts?.forEach((part) => {
    const match = part.match(/^(\w+)\(([^:()]+)(?::([^:()]+))?\)$/);

    if (match) {
      const [, attribute, type, color] = match;

      if (attribute === bodyPart) {
        result = {
          part: attribute,
          type: type || null,
          color: color || null,
        };
      }
    }
  });

  return result;
};

export const compareSpriteDescriptions = (description1, description2) => {
  const parseDescription = (description) => {
    const result = {};
    const parts = description?.split("-");

    parts?.forEach((part) => {
      const match = part.match(/^([a-z]{2})\(([^:()]+)(?::([^:()]+))?\)$/);

      if (match) {
        const [, attribute, type, color] = match;
        result[attribute] = { type: type || null, color: color || null };
      }
    });

    return result;
  };

  const parsed1 = parseDescription(description1);
  const parsed2 = parseDescription(description2);

  const changes = {
    added: {},
    removed: {},
    updated: {},
  };

  // Check for added or updated parts
  Object.keys(parsed2).forEach((key) => {
    if (!parsed1[key]) {
      changes.added[key] = parsed2[key]; // Part was added
    } else if (
      parsed1[key].type !== parsed2[key].type ||
      parsed1[key].color !== parsed2[key].color
    ) {
      changes.updated[key] = {
        from: parsed1[key],
        to: parsed2[key],
      }; // Part was updated
    }
  });

  // Check for removed parts
  Object.keys(parsed1).forEach((key) => {
    if (!parsed2[key]) {
      changes.removed[key] = parsed1[key]; // Part was removed
    }
  });

  return changes;
};
